import common from '@/store/common/mutations';
import * as types from './mutation-types';

import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

import { SEARCH_PARAMS, PWA_APCN_POPUP, PAGING_INFO } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.pwaApcnList = []; //그리드리스트
		state.prcsStepList = []; //조회조건 처리단계
		state.gridPrcStepList = []; //그리드안에 사용여부
		state.prcsRsltList = []; //조회조건 처리결과
		state.pwaDdList = []; //조회조건 날자선택값
		state.popupSearchParams = POPUP_SEARCH_PARAM();

		state.isMqyStation = false;
	},
	[types.STATE_APCN_INIT]: state => {
		state.pwaApcnPopUp = PWA_APCN_POPUP(); //디테일조회시
		state.savePwaApcn = PWA_APCN_POPUP(); //저장시
		state.pwaApcnSwapPartsList = []; //PWA신청팝업 교환부품정보
		state.apprCommentList = [];
		state.fileList = []; //파일첨부
		state.occuRegnListPop = []; //PWA신청팝업 PWA기초 정보 발생지역
		state.causCdListPop = []; //PWA신청현황 PWA기초 정보 원인코드
		state.ctypeList = []; //PWA신청현황 PWA기초 정보 Ctype
		state.isSaveFlag = false;
		state.prcStateCd = '';
		state.tmpCustSaleDd = ''; //임시 고객판매일자
		state.tmpDgnDd = ''; //임시 진단일자.
		state.otherFeeList = [];
		state.feeTypeOptions = [];
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.APCN_INFO]: (state, { key, value }) => {
		state.pwaApcnPopUp[key] = value;
	},
	[types.APCN_SAVE_INFO]: (state, { key, value }) => {
		state.savePwaApcn[key] = value;
	},
	[types.POPUP_SEARCH_PARAM]: (state, payload) => {
		state.popupSearchParams[payload.key] = payload.value;
	}
};
